// extracted by mini-css-extract-plugin
export default {"treeRoot":"AITagsSelection_treeRoot__4wWM+","draggingSource":"AITagsSelection_draggingSource__ldwNw","dropTarget":"AITagsSelection_dropTarget__fOOm+"};